<div>
  <ng-container [ngSwitch]="item.payload.type">
    <div class="icon-type" *ngSwitchCase="'saved_reports_folder'">
      <mat-icon>folder</mat-icon>
    </div>
    <div class="icon-type" [ngStyle]="{ 'background-color': badgeColors[item.payload.attributes.report_type] }" *ngSwitchCase="'saved_report'">
      <mat-icon>{{ item.payload.attributes.report_icon }}</mat-icon>
    </div>
  </ng-container>
</div>
<div class="overflow-hidden">
  <div class="overflow-hidden">
    <div class="text-ellipsis item-name"
         [@enlargeText]="{
          value: enlargeText,
          params: {
            fontWeight: 400,
            fontSize: '1rem',
            enlargeFontWeight: 500,
            enlargeFontSize: '1.05rem'
          }
         }">{{ item.name$ | async }}</div>
    <div class="path-container overflow-hidden">
      <mat-icon class="icon-path">folder</mat-icon>
      <ng-container *ngFor="let item of item.path$ | async">
        <span>></span>
        <span class="text-ellipsis">{{ item.name$ | async }}</span>
      </ng-container>
    </div>
  </div>
</div>
<div class="search-results-actions-container">
  <button mat-icon-button *ngIf="!showActions; else actions">
    <mat-icon class="icon-more">more_vert</mat-icon>
  </button>
  <ng-template #actions>
    <div class="search-results-actions-container"
         [@showSlideRight]="'show'">
      <button mat-icon-button
              appClickStopPropagation
              (click)="onFilter.emit()">
        <mat-icon class="icon-new"
                  [customToolTip]="'reports.tooltip.filter_on_page' | translate">search</mat-icon>
      </button>
    </div>
    <button mat-icon-button>
      <mat-icon [customToolTip]="'reports.tooltip.open_report_folder' | translate"
                class="icon-done">chevron_right</mat-icon>
    </button>
  </ng-template>
</div>
